import { Head } from '@inertiajs/react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'

interface PublicShowProps {
  workspace: { name: string }
  page: {
    title: string
    content_md: string
    updated_at: string
  }
}

export default function PublicShow({ workspace, page }: PublicShowProps) {
  const editor = useEditor({
    extensions: [StarterKit, Markdown],
    content: page.content_md,
    editable: false,
  })

  return (
    <div className="min-h-screen bg-white">
      <Head title={`${page.title} - ${workspace.name}`} />

      <header className="border-b border-gray-200 bg-gray-50 px-6 py-4">
        <p className="text-sm text-gray-500">{workspace.name}</p>
        <h1 className="text-2xl font-bold text-gray-900">{page.title}</h1>
        <p className="mt-1 text-xs text-gray-400">
          Last updated: {new Date(page.updated_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-8">
        <div className="prose max-w-none">
          {editor ? (
            <EditorContent editor={editor} />
          ) : (
            <div className="whitespace-pre-wrap">{page.content_md}</div>
          )}
        </div>
      </main>
    </div>
  )
}
